<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-12">
        <h2>Log in to <span class="font-bold">sleep&me</span></h2>
      </div>
      <!-- TODO: Move Google button to component by making ActionButton a Vue Slot -->
      <button @click="googleSignIn()" class="button-secondary inline-flex items-center">
        <img src="@/assets/google.svg" class="mr-2">
        <span>Sign in with Google</span>
      </button>
<!--       <LoadingButton
        :disabled='loading'
        :label='buttonLabel'
        :loading='buttonLoading'
        @action-function="login"
      /> -->
    </div>
  </div>


<!--     <div>
      <button v-if="!user" @click="googleSignIn()">Sign In</button>
      <button v-else @click="googleSignOut()">Log Out</button>
    </div> -->
</template>

<script>
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth'
// import LoadingButton from '@/components/LoadingButton'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'LoginPage',
  components: [
    // LoadingButton,
  ],
  data() {
    return {
      user: undefined,
    }
  },
  beforeMount() {
  },
  methods: {
    googleSignIn() {
      const auth = getAuth()
      signInWithPopup(auth, new GoogleAuthProvider())
        .then(async () => {
          // Load the logged in user into the user store.
          await this.userStore.load()
          this.$router.push('/')
        })
        .catch((reason) => {
          console.error('Failed signInWithPopup', reason)
        })
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>